import useTable from '../useTable'

export const useFilterTags = () => {
  const { query } = useTable<any>({ useQueryParams: true })

  return {
    query
  }
}
